.rangeSelectFilterContainer {
  display: flex;
  flex-direction: column;
}

.rangeSelectFilterLabel {
  margin-bottom: var(--cxy-spacing-1);
  font-size: var(--cxy-fontSize-s);
}

.rangeSelectFilterItems {
  display: flex;
  gap: var(--cxy-spacing-4);
}

.rangeSelectFilterItem {
  flex: 1;
}
